<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      visible
      direction="rtl"
      :size="700"
      :before-close="() => $refs.main.cancel()"
      @close="close"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          :isAdd="isAdd"
          :reportBudgetSetCustCode="reportBudgetSetCustCode"
          @close="close"
          @reload="$emit('reload')"
        />
      </div>
      <div class="drawer-footer" v-if="!disabled">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ this.$l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="$refs.main.save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    title: { type: String, default: '' },
    isAdd: { type: Boolean, default: false },
    reportBudgetSetCustCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 32px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
